import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function LoginPage({ setActivePage }) {
  const { loginUser, users } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Please enter both email and password.');
      return;
    }

    setIsSubmitting(true);
    setTimeout(() => {
      const result = loginUser(email, password);
      setIsSubmitting(false);

      if (result.success) {
        setActivePage('dashboard');
      } else {
        setError(result.message);
      }
    }, 300);
  };

  const handleQuickLogin = (demoEmail, demoPass) => {
    setEmail(demoEmail);
    setPassword(demoPass);
    const result = loginUser(demoEmail, demoPass);
    if (result.success) {
      setActivePage('dashboard');
    } else {
      setError(result.message);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-12">
      <div className="bg-white rounded-3xl shadow-xl border border-slate-200 overflow-hidden">
        <div className="bg-slate-900 px-8 py-6 text-white text-center space-y-1">
          <h1 className="text-2xl font-bold tracking-tight">Welcome Back</h1>
          <p className="text-slate-400 text-xs">Sign in to your registered account</p>
        </div>

        <form onSubmit={handleSubmit} className="p-8 space-y-6">
          {error && (
            <div className="bg-rose-50 border border-rose-200 text-rose-700 px-4 py-3 rounded-xl text-sm flex items-center space-x-3">
              <svg className="w-5 h-5 text-rose-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
              <span>{error}</span>
            </div>
          )}

          <div className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-slate-700 uppercase tracking-wider mb-1">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="e.g. admin@example.com"
                required
                className="w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-xl text-slate-900 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-700 uppercase tracking-wider mb-1">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-xl text-slate-900 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-3 px-6 rounded-xl shadow-md transition-colors flex items-center justify-center space-x-2"
          >
            {isSubmitting ? <span>Signing In...</span> : <span>Sign In</span>}
          </button>

          {/* Quick Demo Credentials */}
          <div className="border-t border-slate-200 pt-6 space-y-3">
            <div className="text-xs font-semibold text-slate-400 uppercase tracking-wider text-center">
              Quick Demo Login
            </div>
            <div className="grid grid-cols-2 gap-2">
              {users.slice(0, 2).map((u) => (
                <button
                  key={u.id}
                  type="button"
                  onClick={() => handleQuickLogin(u.email, u.password)}
                  className="text-xs bg-slate-100 hover:bg-slate-200 text-slate-700 p-2.5 rounded-xl border border-slate-200 text-left transition-colors"
                >
                  <div className="font-semibold truncate">{u.name}</div>
                  <div className="text-[10px] text-slate-500 truncate">{u.role}</div>
                </button>
              ))}
            </div>
          </div>

          <div className="text-center pt-2 text-xs text-slate-500">
            Don't have an account yet?{' '}
            <button
              type="button"
              onClick={() => setActivePage('register')}
              className="text-blue-600 font-semibold hover:underline"
            >
              Go to Registration Page
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
